export default __webpack_public_path__ + "static/media/noPracticeGuidelinesForPatientBrief.1be2ab66.png";